import { Navigate, Outlet } from 'react-router';

import GlobalSuspenseFallback from '~/pages/Fallback/GlobalSuspenseFallback';

import { useAppEnv } from './useAppEnv';

/**
 * @description 웹뷰 전용 라우트 그룹 Guard
 * - 브릿지 응답 대기 중: 로딩 화면
 * - 웹뷰/개발 모드: 하위 라우트 진입 허용
 * - 그 외(브라우저/무응답): 루트로 이동 (RootGuard가 가이드 또는 에러 화면 처리)
 */
const WebViewOnly = () => {
  const { bridgeStatus, isWebView, isDevMode } = useAppEnv();

  if (isDevMode) {
    return <Outlet />;
  }

  if (bridgeStatus === 'pending') {
    return <GlobalSuspenseFallback />;
  }

  return isWebView ? <Outlet /> : <Navigate to="/" replace />;
};

export default WebViewOnly;
